import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Chip from 'fuse-ui/components/Chip';
import { withStyles } from '@material-ui/core/styles';

import { translate } from '../../utils/translation-utils';
import { DOMAIN_HIERARCHY_PARENT, DOMAIN_HIERARCHY_SUBDOMAIN } from '../../common/constants/definitions';

const styles = theme => ( {
    chipButton: {
        marginRight: 16,
        textTransform: 'capitalize'
    },
    root: {
        marginBottom: 16
    }
} );

export const TabFilterButtons = ( { classes, domainType, match, selectedDomainFilter } ) => {
    return (
        <div className={classes.root}>
            <Chip
                clickable
                className={classes.chipButton}
                component={Link}
                data-automation-id={`${domainType}-parent-domains-filter-chip`}
                label={translate( DOMAIN_HIERARCHY_PARENT )}
                selected={selectedDomainFilter === DOMAIN_HIERARCHY_PARENT}
                size="medium"
                to={`${match.url}?domainHierarchy=${DOMAIN_HIERARCHY_PARENT}`}
            />
            <Chip
                clickable
                className={classes.chipButton}
                component={Link}
                data-automation-id={`${domainType}-subdomains-filter-chip`}
                label={translate( DOMAIN_HIERARCHY_SUBDOMAIN )}
                selected={selectedDomainFilter === DOMAIN_HIERARCHY_SUBDOMAIN}
                size="medium"
                to={`${match.url}?domainHierarchy=${DOMAIN_HIERARCHY_SUBDOMAIN}`}
            />
        </div>
    );
};

TabFilterButtons.propTypes = {
    classes: PropTypes.object,
    domainType: PropTypes.string.isRequired,
    match: PropTypes.shape( {
        params: PropTypes.shape( {
            collectionId: PropTypes.string
        } ),
        url: PropTypes.string,
    } ),
    selectedDomainFilter: PropTypes.string
};

export default withStyles( styles )( TabFilterButtons );
